import { isUndNullEmp } from '../../helpers/main.js';

export class Company {
    constructor(
        _id = 0,
        _name = '',
        _nit = '',
        _phones = '',
        _fax = '',
        _address = '',
        _email = '',
        _webSite = '',
        _secundaryId = '',
        _rif = '',
        _isAvailable = false,
        _registerDate = '',
        _countryId = 0,
    ) {
        this.id = _id;
        this.name = _name;
        this.nit = _nit;
        this.phones = _phones;
        this.fax = _fax;
        this.address = _address;
        this.email = _email;
        this.webSite = _webSite;
        this.secundaryId = _secundaryId;
        this.rif = _rif;
        this.isAvailable = _isAvailable;
        this.registerDate = _registerDate;
        this.countryId = _countryId;
    }

    static getClassName = () => {
        return 'Company - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 1,
                    Name: 4,
                    Nit: 0,
                    Phones: 0,
                    Fax: 0,
                    Address: 10,
                    Email: 10,
                    WebSite: 10,
                    SecundaryId: 4,
                    Rif: 10,
                    IsAvailable: 1,
                    RegisterDate: 10,
                    CountryId: 1,
                },
                max: {
                    Id: 450,
                    Name: 100,
                    Nit: 18,
                    Phones: 60,
                    Fax: 60,
                    Address: 450,
                    Email: 60,
                    WebSite: 200,
                    SecundaryId: 8,
                    Rif: 12,
                    IsAvailable: 1,
                    RegisterDate: 30,
                    CountryId: 450,
                },
            };
        } else {
            return {
                min: {
                    id: 1,
                    name: 4,
                    nit: 0,
                    phones: 0,
                    fax: 0,
                    address: 10,
                    email: 10,
                    webSite: 10,
                    secundaryId: 4,
                    rif: 10,
                    isAvailable: 1,
                    registerDate: 10,
                    countryId: 1,
                },
                max: {
                    id: 450,
                    name: 100,
                    nit: 18,
                    phones: 60,
                    fax: 60,
                    address: 450,
                    email: 60,
                    webSite: 200,
                    secundaryId: 8,
                    rif: 12,
                    isAvailable: 1,
                    registerDate: 30,
                    countryId: 450,
                },
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: Company.getClassName() })?.result) {
            if (upperCase) {
                return new Company(
                    obj.Id,
                    obj.Name,
                    obj.Nit,
                    obj.Phones,
                    obj.Fax,
                    obj.Address,
                    obj.Email,
                    obj.WebSite,
                    obj.SecundaryId,
                    obj.Rif,
                    obj.IsAvailable,
                    obj.RegisterDate,
                    obj.CountryId,
                );
            } else {
                return new Company(
                    obj.id,
                    obj.name,
                    obj.nit,
                    obj.phones,
                    obj.fax,
                    obj.address,
                    obj.email,
                    obj.webSite,
                    obj.secundaryId,
                    obj.rif,
                    obj.isAvailable,
                    obj.registerDate,
                    obj.countryId,
                );
            }
        } else {
            return new Company();
        }
    }
}